// Our team's Amigo log (D8). Wording from the Amigo design's copy sheet (Amigo log, Amigo log couldn't do, Amigo log no
// results, Row status); FoodAmigos only, so always Amigo, never the assistant.
export default {
  title: 'Journal Amigo',
  intro:
    "Chaque demande traitée par Amigo : ce qui a été demandé, où, qui l'a demandé et qui l'a approuvé. Seul FoodAmigos voit cette page.",
  // The tab list's name for screen readers.
  tabs_label: 'Journal Amigo',
  tabs: {
    requests: 'Demandes',
    gaps: 'Non réalisé',
  },
  filters: {
    restaurant: 'Restaurant',
    all_restaurants: 'Tous les restaurants',
    brand: '{{name}} · Marque',
    restaurant_unknown: 'Restaurant {{id}}',
    searching: 'Recherche de restaurants…',
    no_restaurant: 'Aucun restaurant nommé « {{query}} »',
    period: 'Période',
    start_date: 'Date de début',
    end_date: 'Date de fin',
    refresh: 'Actualiser',
    gap: 'Demandé : {{request}}',
    change_set: "La demande à l'origine d'une modification",
    remove: 'Retirer le filtre : {{label}}',
    clear: 'Effacer les filtres',
  },
  columns: {
    steps: 'Étapes',
    when: 'Quand',
    request: 'Demande',
    restaurant: 'Restaurant',
    asked_by: 'Demandé par',
    result: 'Résultat',
  },
  show_steps: 'Afficher les étapes de : {{request}}',
  approved_by: 'Approuvé par {{name}}',
  nothing_approved: "Rien d'approuvé",
  results: {
    applied: '{{applied}} appliquée(s)',
    applied_skipped: '{{applied}} appliquée(s) · {{skipped}} ignorée(s)',
    partial: '{{applied}} sur {{total}} appliquée(s)',
    imported: 'Importé',
    importing: 'Importation en cours',
    waiting: "En attente d'approbation",
    rejected: 'Rejeté',
    undone: 'Annulé',
    expired: 'Expiré',
    replaced: 'Remplacé',
    failed: 'Échec',
    answered: 'Répondu',
    not_yet: 'Pas encore possible',
    off_limits: 'Interdit',
    not_allowed: 'Non autorisé',
    switched_off: 'Désactivé',
    guard: 'Arrêté par un contrôle de sécurité',
    not_found: 'Introuvable',
  },
  steps: {
    asked: '{{name}} a demandé',
    asked_anonymous: 'Demandes',
    approved: 'Approuvé par {{name}}',
    approved_alone: 'Approuvé',
    applied_one: '{{count}} modification appliquée',
    applied_other: '{{count}} modifications appliquées',
    failed_one: '{{count}} non appliquée(s)',
    failed_other: '{{count}} non appliquée(s)',
    rejected: 'Rejeté',
    undone: 'Annulé',
    skipped_one: '{{count}} ignoré(s)',
    skipped_other: '{{count}} ignoré(s)',
    skipped_state: 'Ignoré',
    more_one: 'et {{count}} de plus',
    more_other: 'et {{count}} de plus',
    changes_one: '{{count}} modification',
    changes_other: '{{count}} modifications',
    other: 'Vérification en cours',
  },
  // The line over a request's steps (QA49): how many, how many shop refused, how many failed.
  summary: {
    steps_one: '{{count}} étape',
    steps_other: '{{count}} étapes',
    refused_one: '{{count}} refusé(s)',
    refused_other: '{{count}} refusé(s)',
    failed_one: '{{count}} échoué(s)',
    failed_other: '{{count}} échoué(s)',
  },
  // A request that changed nothing says what came of it, under Result (design: Log · steps open).
  outcomes: {
    title: 'Résultat',
    answered: "Une réponse : rien n'a changé.",
    waiting: "En attente d'approbation. Rien n'a encore changé.",
    rejected: "Refusé : rien n'a changé.",
    expired: "Expiré sans approbation : rien n'a changé.",
    replaced: "Remplacé par une carte plus récente : rien n'a changé ici.",
    undone: 'Annulé : les modifications ont été annulées.',
    failed: "Échec : rien n'a changé.",
    not_yet: "Impossible pour l'instant : rien n'a changé. Comptabilisé dans Impossible à faire.",
    off_limits: "Hors périmètre : rien n'a changé.",
    not_allowed: "Non autorisé pour le rôle de cette personne : rien n'a changé.",
    switched_off: "Désactivé ici : rien n'a changé.",
    guard: "Bloqué par un contrôle de sécurité : rien n'a changé.",
    not_found: "Introuvable : rien n'a changé.",
    importing: 'Importation en cours. Chaque plat est ajouté à Menu → Historique des modifications.',
    imported: 'Importé. Chaque plat figure dans Menu → Historique des modifications.',
  },
  changes: {
    // With where they were made: "3 changes · Hilltop Burger · Ehrenfeld".
    where: '{{changes}} · {{where}}',
    title_one: '{{count}} modification',
    title_other: '{{count}} modifications',
    show_all: 'Afficher les {{count}} modifications',
    show_fewer: 'Afficher moins',
    from: 'de',
    to: 'à',
    removed: 'Supprimé',
  },
  row_states: {
    skipped: 'Ignoré',
    failed: 'Non appliqué',
    stale: 'Modifié entre-temps',
    kept: 'Laissé tel quel',
  },
  menu_history: 'Ouvrir Menu → Historique des modifications',
  // Opens the request's chat in the Amigo panel, on its restaurant (read only when someone else started it).
  open_chat: 'Ouvrir le chat',
  // Both links first switch the dashboard to the request's restaurant; this says that didn't work.
  switch_failed: "Impossible d'ouvrir ce restaurant. Réessayez.",
  pagination: {
    label: 'Pages',
    summary: '{{from}}–{{to}} sur {{total}} demandes',
    previous: 'Page précédente',
    next: 'Page suivante',
  },
  empty: {
    title: 'Aucune demande pour {{restaurant}} sur cette période',
    text: "Amigo n'a rien traité là-bas entre le {{from}} et le {{to}}.",
    title_any_day: "Aucune demande pour {{restaurant}} pour l'instant",
    text_any_day: "Amigo n'a encore rien traité là-bas.",
    title_everywhere: 'Aucune demande sur cette période',
    text_everywhere: "Amigo n'a rien traité entre le {{from}} et le {{to}}.",
    title_nothing: "Aucune demande pour l'instant",
    text_nothing: "Amigo n'a encore rien traité.",
  },
  loading: 'Chargement…',
  error: {
    title: 'Impossible de charger le journal',
    text: 'Réessayez dans un instant.',
    retry: 'Réessayer',
  },
  gaps: {
    intro:
      "Ce qu'Amigo n'a pas encore pu faire, regroupé par demande, les plus fréquentes en premier. Les demandes interdites ou non autorisées pour un rôle n'apparaissent pas ici.",
    columns: {
      area: 'Domaine',
      request: 'Ce que les gens ont demandé',
      count: 'Demandes',
      last_at: 'Dernière demande',
      requests: 'Demandes',
    },
    count: '{{count}}×',
    see_requests_one: 'Voir {{count}} demande',
    see_requests_other: 'Voir {{count}} demandes',
    today: "Aujourd'hui, {{time}}",
    yesterday: 'Hier, {{time}}',
    empty_title: "Aucune demande qu'Amigo n'a pas pu traiter",
    empty_text: 'Tout ce que les gens ont demandé, Amigo a pu le faire.',
  },
  areas: {
    menu: 'Menu',
    hours: "Horaires d'ouverture",
    order_settings: 'Paramètres des commandes',
    my_info: 'Mes infos',
    marketing: 'Marketing',
    gift_cards: 'Cartes cadeaux',
    reports: 'Rapports',
    website: 'Site web',
    integrations: 'Intégrations',
    delivery: 'Livraison',
    payments: 'Paiements',
    team: 'Équipe',
    billing: 'Facturation',
    settings: 'Paramètres',
    other: 'Autre',
  },
};
